export default {
  search: 'recherche',
  searchPlaceholder: 'Cherchez un projet, une technologie...',
  navigation: 'navigation',
  noResult: "Aucun résultat n'a été trouvé",
};
